import { configureStore } from "@reduxjs/toolkit";

import { setupListeners } from "@reduxjs/toolkit/query";
import { paymentsApi } from "../services/payments/payments";
import { itemsApi } from "../services/items/items";
import { budgetApi } from "../services/budget/budget";
import { educationApi } from "../services/education/education";
import { favoritesApi } from "../services/favorites/favorites";
import { bannersApi } from "../services/banners/banners";
import { deliveryZonesApi } from "../services/deliveryZones/deliveryZones";
import { alegraItemsApi } from "../services/alegraItems/alegraItems";
import { alegraSyncApi } from "../services/alegraSync/alegraSync";
// Tiendas Biai. A separate slice with its own base URL and its own auth tenant — never an endpoint
// added to a storefront slice, where a TBS change could invalidate a storefront cache tag.
import { tbsContactsApi } from "../services/tbsContacts/tbsContacts";
import { tbsItemsApi } from "../services/tbsItems/tbsItems";
import { tbsConfigApi } from "../services/tbsConfig/tbsConfig";
import { tbsInvoicesApi } from "../services/tbsInvoices/tbsInvoices";
import { tbsPaymentsApi } from "../services/tbsPayments/tbsPayments";
import { tbsShiftsApi } from "../services/tbsShifts/tbsShifts";
import { tbsReportsApi } from "../services/tbsReports/tbsReports";
import authReducer from "../services/auth/authSlice";
import cartReducer from "../services/cartSlice/cartSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [itemsApi.reducerPath]: itemsApi.reducer,
    [budgetApi.reducerPath]: budgetApi.reducer,
    [educationApi.reducerPath]: educationApi.reducer,
    [favoritesApi.reducerPath]: favoritesApi.reducer,
    [bannersApi.reducerPath]: bannersApi.reducer,
    [deliveryZonesApi.reducerPath]: deliveryZonesApi.reducer,
    [alegraItemsApi.reducerPath]: alegraItemsApi.reducer,
    [alegraSyncApi.reducerPath]: alegraSyncApi.reducer,
    [tbsContactsApi.reducerPath]: tbsContactsApi.reducer,
    [tbsItemsApi.reducerPath]: tbsItemsApi.reducer,
    [tbsConfigApi.reducerPath]: tbsConfigApi.reducer,
    [tbsInvoicesApi.reducerPath]: tbsInvoicesApi.reducer,
    [tbsPaymentsApi.reducerPath]: tbsPaymentsApi.reducer,
    [tbsShiftsApi.reducerPath]: tbsShiftsApi.reducer,
    [tbsReportsApi.reducerPath]: tbsReportsApi.reducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(paymentsApi.middleware)
      .concat(itemsApi.middleware)
      .concat(budgetApi.middleware)
      .concat(educationApi.middleware)
      .concat(favoritesApi.middleware)
      .concat(bannersApi.middleware)
      .concat(alegraItemsApi.middleware)
      .concat(alegraSyncApi.middleware)
      .concat(deliveryZonesApi.middleware)
      .concat(tbsContactsApi.middleware)
      .concat(tbsItemsApi.middleware)
      .concat(tbsConfigApi.middleware)
      .concat(tbsInvoicesApi.middleware)
      .concat(tbsPaymentsApi.middleware)
      .concat(tbsShiftsApi.middleware)
      .concat(tbsReportsApi.middleware),
});

setupListeners(store.dispatch);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
